import {connect} from 'react-redux';
import {
    setThumbnails,
    resetThumbnails,
    SetThumbnails,
    ResetThumbnails,
} from './Redux/ThumbnailsActions';
import ThumbnailsContainer from './ThumbnailsContainer';
import {ThumbnailsState} from './Redux/ThumbnailsReducer';
import {ThumbnailMarker} from '../TimelineTypes';

interface DispatchProps {
    setThumbnails: SetThumbnails;
    resetThumbnails: ResetThumbnails;
}

interface StateProps {
    markers: ThumbnailMarker[];
}

interface TimelineStore {
    thumbnails: ThumbnailsState;
}

export interface State {
    timeline: TimelineStore;
}

export const mapState = (state: State): StateProps => {
    const {markers} = state.timeline.thumbnails;
    return {
        markers,
    };
};

export const mapDispatch: DispatchProps = {
    setThumbnails,
    resetThumbnails,
};

export default connect(mapState, mapDispatch)(ThumbnailsContainer);
